<template>
  <div v-if="grades.length">
    <div class="detail-layout-section-title">
      <h3>{{ $texts('accessibility') }}</h3>
    </div>

    <figure class="travel-details">
      <table class="is-fullwidth mb-0 table">
        <tbody>
          <tr v-for="rating in grades" :key="rating.gradeName">
            <th>{{ rating.ratingProfileName }}</th>
            <td class="!pr-0 !text-right">
              {{ rating.gradeName }}
              <span :class="`grade-color grade-color--${rating.grade}`" />
            </td>
          </tr>
        </tbody>
      </table>
    </figure>

    <div>
      <a
        v-if="url"
        :href="url"
        target="_blank"
        rel="noopener"
        class="link with-arrow mt-size-6"
      >
        {{ $texts('moreInformation') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  nid: string
}>()

const { grades, url } = await useAccessibilityInfo(() => props.nid)
</script>

<style lang="postcss" scoped>
.grade-color {
  @apply ml-2.5 inline-block h-3.5 w-3.5 rounded-full;

  &--1 {
    @apply bg-success;
  }
  &--2 {
    @apply bg-warning;
  }
  &--3 {
    @apply bg-danger;
  }
}
</style>
